import { apiWorker } from "..";

export default async function GetLogs() {
  const data = await fetch(`${apiWorker}/logs`).then(res => res.json())
  const {logs} = data
  return logs
}
